import React, { Component } from 'react';
import { withRouter } from 'react-router';

import { FileService } from 'modules/file';
import { UPLOAD_STATUS, ENTITY_TYPE } from 'modules/file/constants';
import { UiService } from 'modules/ui';
import PropTypes from 'prop-types';

import ContentEditor from './ContentEditor';

import { UploadManager } from '@hotmart/club-files-ui';

@withRouter
class ContentEditorUploadWrapper extends Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string
      })
    })
  };

  state = { redactorUploader: null };

  emptyImages = [];

  setRedactorUploader = (redactorUploader, fileUpload) => {
    this.setState({ redactorUploader, fileUpload });
  };

  saveRedactorImage = (items) => {
    const { redactorUploader } = this.state;

    if (!redactorUploader) {
      return;
    }

    redactorUploader.close();
    const image = items[0] || {};

    if (image.status === UPLOAD_STATUS.FINISHED) {
      redactorUploader.onSuccess(image.id, this.popImage);
    }
  };

  popImage = (imageId) => {
    const { fileUpload } = this.state;

    fileUpload.actions.delete(imageId);
  };

  onError = (message, data) => UiService.setAlertError(message, data);

  render() {
    return (
      <UploadManager
        itemsProp="images"
        images={this.emptyImages}
        entityId={this.props.match.params.id}
        onItemsChange={this.saveRedactorImage}
        onError={FileService.handleFileException}
        entity={ENTITY_TYPE.PAGE_CONTENT_IMG}
        setCentralError={this.onError}
      >
        <ContentEditor
          {...this.props}
          setRedactorUploader={this.setRedactorUploader}
        />
      </UploadManager>
    );
  }
}

export default ContentEditorUploadWrapper;
